var map = {
	"./CoinFlip.json": [
		2981
	],
	"./DICY.json": [
		7584
	],
	"./GameInterface.json": [
		4664,
		664
	],
	"./GameMaker.json": [
		9247
	],
	"./GameRegistry.json": [
		8538
	],
	"./Mill.json": [
		1793
	],
	"./OracleBet.json": [
		7964
	],
	"./RiskSimple.json": [
		2246
	],
	"./RockPaperScissors.json": [
		8483
	],
	"./TicTacToe.json": [
		1101
	],
	"./contract-address.json": [
		4756
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8922;
module.exports = webpackAsyncContext;